import * as React from "react";
const SvgCheckboxDefault = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} fill="none" {...props}>
    <path fill="#fff" d="M1 7a6 6 0 0 1 6-6h4a6 6 0 0 1 6 6v4a6 6 0 0 1-6 6H7a6 6 0 0 1-6-6z" />
    <path
      fill="#A6A6A6"
      fillRule="evenodd"
      d="M11 2H7a5 5 0 0 0-5 5v4a5 5 0 0 0 5 5h4a5 5 0 0 0 5-5V7a5 5 0 0 0-5-5M7 1a6 6 0 0 0-6 6v4a6 6 0 0 0 6 6h4a6 6 0 0 0 6-6V7a6 6 0 0 0-6-6z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCheckboxDefault;
